import { render, staticRenderFns } from "./SpecialCategories.vue?vue&type=template&id=60a793fe&"
import script from "./SpecialCategories.vue?vue&type=script&lang=js&"
export * from "./SpecialCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports